// Event Bus 插件
// 迁移自 main.js 中的 $bus
// 服务端也需注册，否则组件 created() 中 this.$bus.$on 会报 undefined

import Vue from 'vue'

export default function (context) {
  if (!Vue.prototype.$bus) {
    Vue.prototype.$bus = new Vue()
  }
}
